import { z } from "zod";

export const createPatientSchema = (t: any, validate: any) =>
  z.object({
    FullName: z
      .string()
      .trim()
      .min(1, { message: t("required_field") })
      .min(4, { message: t("fullname_min_length_4") })
      .max(50, { message: "FullName cannot exceed 50 characters" }),

    PhoneNumber: z
      .string()
      .trim()
      .min(1, { message: t("phone_number_required") })
      .superRefine((value, ctx) => {
        if (!validate) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t("validation_configuration_error"),
          });
          return;
        }

        const phoneNumber = value.replace(/[^0-9]/g, "");
        const countryStart = validate.Start.toString();
        const countryLength = validate.Length;

        const startWith0 = `0${countryStart}`;
        const startWithCountryStart = countryStart;

        if (phoneNumber.startsWith(startWith0)) {
          if (phoneNumber.length !== countryLength + 1) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t("phone_number_must_be_and_start_with", {
                length: countryLength + 1,
                start: startWith0,
              }),
            });
          }
        } else if (phoneNumber.startsWith(startWithCountryStart)) {
          if (phoneNumber.length !== countryLength) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t("phone_number_must_be_and_start_with", {
                length: countryLength,
                start: startWithCountryStart,
              }),
            });
          }
        } else {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t("phone_number_must_start_with", {
              start1: startWithCountryStart,
              start2: startWith0,
            }),
          });
        }
      }),

    Birthday: z
      .string()
      .trim()
      .min(1, { message: t("required_field") }),

    Gender: z
      .string()
      .trim()
      .min(1, { message: t("required_field") }),
  });

export const linkPatientSchema = (t: any) =>
  z.object({
    FullName: z
      .string()
      .trim()
      .min(1, { message: t("required_field") })
      .min(4, { message: t("fullname_min_length_4") })
      .max(50, { message: "FullName cannot exceed 50 characters" }),

    PhoneNumber: z
      .string()
      .trim()
      .min(1, { message: t("phone_number_required") }),

    Birthday: z
      .string()
      .trim()
      .min(1, { message: t("required_field") }),

    Gender: z
      .string()
      .trim()
      .min(1, { message: t("required_field") }),
  });
